/**
 * 마을 NPC. 플레이어 스탠드 스프라이트를 색만 바꿔 쓴다.
 */

import Phaser from 'phaser';
import type { AssetTable } from '../assets/loader';
import { getNpc, type NpcDef } from '../data/npcs';
import { DEPTH } from '../game/depth';
import { TEXT_COLOR, UI_FONT } from '../ui/theme';

export class Npc extends Phaser.GameObjects.Container {
  readonly def: NpcDef;

  constructor(scene: Phaser.Scene, x: number, y: number, npcId: string, assets: AssetTable) {
    const def = getNpc(npcId);
    super(scene, x, y);
    if (!def) throw new Error(`unknown npc ${npcId}`);
    this.def = def;

    const sprite = scene.add.sprite(0, 0, 'player-stand', 0).setOrigin(0.5, 1);
    const scale = assets.scaleFor('player-stand');
    sprite.setScale(scale).setTint(def.tint);
    const name = scene.add
      .text(0, -PlayerNameY(assets), def.name, {
        fontFamily: UI_FONT,
        fontSize: '13px',
        color: TEXT_COLOR.bright,
        stroke: '#14141c',
        strokeThickness: 4,
        wordWrap: { width: 140, useAdvancedWrap: true },
        align: 'center',
      })
      .setOrigin(0.5, 1);
    this.add([sprite, name]);
    this.setDepth(DEPTH.npc);
    scene.add.existing(this);
  }
}

function PlayerNameY(assets: AssetTable): number {
  return assets.get('player-stand').displayHeight + 8;
}
